(() => {
  const overlays = document.querySelectorAll('.stw-overlay[id^="spin-to-win-"]');
  if (!overlays.length) return;

  overlays.forEach((overlay) => {
    const sectionId = overlay.dataset.sectionId;
    const delay = Number(overlay.dataset.delay || 1500);
    const cookieDays = Number(overlay.dataset.cookieDays || 7);
    const wheelCanvas = overlay.querySelector(`#stw-wheel-${sectionId}`);
    const spinBtn = overlay.querySelector('.stw-spin-btn');
    const closeBtn = overlay.querySelector('.stw-close');
    const form = overlay.querySelector('.stw-form');
    const statusEl = overlay.querySelector('.stw-status');
    const segmentsDataEl = overlay.querySelector('.stw-segments-data');

    if (!wheelCanvas || !spinBtn || !closeBtn || !form || !segmentsDataEl) return;

    const ctx = wheelCanvas.getContext('2d');
    const segments = parseSegments(segmentsDataEl.textContent);
    if (!segments.length) return;

    const computed = getComputedStyle(overlay);
    const accentColor = computed.getPropertyValue('--stw-accent-color') || '#f47c8a';
    const textColor = computed.getPropertyValue('--stw-text-color') || '#7d4550';

    const storageKey = `stw_completed_${sectionId}`;
    const hasCompleted = getStoredState(storageKey, cookieDays);

    if (!hasCompleted) {
      setTimeout(() => showOverlay(overlay), delay);
    }

    drawWheel(ctx, wheelCanvas.width, segments, textColor.trim(), accentColor.trim());

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const emailField = form.querySelector('input[type="email"]');
      const submitBtn = form.querySelector('button[type="submit"]');
      const email = (emailField.value || '').trim();
      if (!email) {
        statusEl.textContent = 'Please enter a valid email.';
        emailField.focus();
        return;
      }

      statusEl.textContent = 'Submitting...';
      submitBtn.disabled = true;

      const payload = new FormData(form);
      payload.set('contact[email]', email);

      fetch(form.getAttribute('action') || '/contact#spin-to-win', {
        method: 'POST',
        body: payload,
        headers: { Accept: 'application/json' },
      })
        .then((res) => {
          if (!res.ok) throw new Error('Request failed');
          statusEl.textContent = 'Great! Tap the button to spin.';
          spinBtn.disabled = false;
        })
        .catch(() => {
          statusEl.textContent = 'Sorry, something went wrong. Try again.';
          submitBtn.disabled = false;
        });
    });

    spinBtn.addEventListener('click', () => {
      if (spinBtn.disabled) return;
      spinBtn.disabled = true;
      const totalRotation = Math.floor(Math.random() * 360) + 720;

      wheelCanvas.style.transition = 'transform 4s cubic-bezier(.17,.67,.35,1.3)';
      wheelCanvas.style.transform = `rotate(${totalRotation}deg)`;

      const revealResult = () => {
        const prize = pickPrize(totalRotation, segments);
        statusEl.textContent = prizeMessage(prize);
        setStoredState(storageKey);
        setTimeout(() => hideOverlay(overlay), 2500);
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        wheelCanvas.style.transition = 'none';
        wheelCanvas.style.transform = 'none';
        revealResult();
      } else {
        setTimeout(revealResult, 4100);
      }
    });

    closeBtn.addEventListener('click', () => {
      hideOverlay(overlay);
      setStoredState(storageKey);
    });
  });

  function showOverlay(element) {
    element.classList.add('is-visible');
  }

  function hideOverlay(element) {
    element.classList.remove('is-visible');
  }

  function parseSegments(jsonString) {
    try {
      const items = JSON.parse(jsonString || '[]');
      return items
        .filter((item) => item && item.label)
        .map((item) => ({
          label: item.label,
          color: item.bg_color || '#fbe6ea',
          coupon: item.coupon_code || '',
        }));
    } catch (error) {
      console.warn('Spin-to-win popup: invalid segment data', error);
      return [];
    }
  }

  function drawWheel(ctx, size, segments, textColor, accentColor) {
    const radius = size / 2;
    ctx.clearRect(0, 0, size, size);

    segments.forEach((segment, index) => {
      const startAngle = (index / segments.length) * 2 * Math.PI;
      const endAngle = ((index + 1) / segments.length) * 2 * Math.PI;

      ctx.beginPath();
      ctx.moveTo(radius, radius);
      ctx.arc(radius, radius, radius, startAngle, endAngle);
      ctx.fillStyle = segment.color;
      ctx.fill();

      ctx.save();
      ctx.translate(radius, radius);
      ctx.rotate(startAngle + (endAngle - startAngle) / 2);
      ctx.textAlign = 'right';
      ctx.fillStyle = textColor || '#7d4550';
      ctx.font = '600 16px "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif';
      ctx.fillText(segment.label, radius - 16, 6);
      ctx.restore();
    });

    ctx.beginPath();
    ctx.arc(radius, radius, 36, 0, 2 * Math.PI);
    ctx.fillStyle = '#ffffff';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(radius, radius, 28, 0, 2 * Math.PI);
    ctx.fillStyle = accentColor || '#f47c8a';
    ctx.fill();
  }

  function pickPrize(rotation, segments) {
    const normalizedRotation = ((rotation % 360) + 360) % 360;
    const degreesPerSlice = 360 / segments.length;
    const index = Math.floor(((360 - normalizedRotation) % 360) / degreesPerSlice);
    return segments[index] || segments[0];
  }

  function prizeMessage(prize) {
    if (!prize) return '';
    return prize.coupon
      ? `You won: ${prize.label}! Use code ${prize.coupon}.`
      : `You won: ${prize.label}!`;
  }

  function getStoredState(key, expiryDays) {
    if (expiryDays === 0) return false;
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return false;
      const data = JSON.parse(raw);
      if (!data.timestamp) return false;
      const age = Date.now() - data.timestamp;
      return age < expiryDays * 24 * 60 * 60 * 1000;
    } catch (error) {
      return false;
    }
  }

  function setStoredState(key) {
    try {
      localStorage.setItem(key, JSON.stringify({ timestamp: Date.now() }));
    } catch (error) {
      // Ignore storage errors (private mode, etc.)
    }
  }
})();

